import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ForcedCheckinSearchService } from './shared/forced-checkin-search.service';
import { ForcedCheckinResult } from './shared/forced-checkin-result';
import { PlantForcedCheckin } from './shared/plant-forced-checkin';
import { LocalLocationService } from '../../local-loads/shared/local-location.service';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import { Region } from '../../user-dashboard/shared/region.model';

export enum ForcedCheckinDateRange {
  ONE_DAY = 'ONE_DAY',
  ONE_WEEK = 'ONE_WEEK',
  ONE_MONTH = 'ONE_MONTH',
}

@Component({
  selector: 'app-forced-checkin',
  templateUrl: './forced-checkin.component.html',
  styleUrls: ['./forced-checkin.component.scss']
})
export class ForcedCheckinComponent {

  public regionIdFromQueryParams = null;
  public selectedPlantGlid: string = null;
  public selectedPlantRadius: number = null;
  public showBucket = true;
  public dateRange: ForcedCheckinDateRange = ForcedCheckinDateRange.ONE_DAY;
  public carrier: Carrier;
  public region: Region;

  public forcedCheckinResult: ForcedCheckinResult[] = [];
  public plantForcedCheckinResult: PlantForcedCheckin[] = [];

  constructor(
    route: ActivatedRoute,
    private searchService: ForcedCheckinSearchService,
    private locationService: LocalLocationService,
  ) {
    route.queryParams
      .subscribe(queryParams => this.regionIdFromQueryParams = queryParams.regionId);
  }

  public selectPlant(glid: string): void {
    if (this.selectedPlantGlid === glid) {
      this.selectedPlantGlid = null;
    } else {
      this.selectedPlantGlid = glid;
      this.reloadPlantResults(glid);
    }
  }

  public reloadPlantResults(glid: string) {
    this.getPlantForcedCheckinMaxRadius(glid);
    this.getPlantForcedCheckins(glid);
  }

  private getPlantForcedCheckins(glid: string): void {
    this.searchService
      .getPlantForcedCheckins(glid, this.dateRange, this.carrier?.id)
      .subscribe((res: PlantForcedCheckin[]) => this.plantForcedCheckinResult = res);
  }

  private getPlantForcedCheckinMaxRadius(glid: string): void {
    this.locationService
      .getForcedCheckinMaxRadius(glid)
      .subscribe(res => this.selectedPlantRadius = res);
  }

  regionSelected($event: Region) {
    this.region = $event;
    this.resetCarrier();
  }

  carrierSelected($event: Carrier) {
    this.carrier = $event;
    this.resetRegion();
  }

  private resetCarrier() {
    this.carrier = undefined;
  }

  private resetRegion() {
    this.region = undefined;
  }
}
